import axios from 'axios';
import api from './api';
import { PainelTvResponse, PainelTvToken } from '../types/operacoes';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

export const painelTvService = {
  // Público: usa axios puro (sem o token de login nem a renovação automática do `api`)
  getPainel: async (token: string): Promise<PainelTvResponse> => {
    const { data } = await axios.get(`${API_URL}/painel-tv/${encodeURIComponent(token)}`);
    return data;
  },

  // Admin
  getToken: async (): Promise<PainelTvToken> => {
    const { data } = await api.get('/operacoes/painel-tv/token');
    return data;
  },

  gerarToken: async (): Promise<PainelTvToken> => {
    const { data } = await api.post('/operacoes/painel-tv/token');
    return data;
  }
};
